import React from "react";
import { observer } from "mobx-react";
import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { Line } from 'react-chartjs-2';
import { Report1Item } from "../../../../stores";
import { ru } from 'date-fns/locale';
import { formatShortDate, formatMoney, formatDateToMask } from "../../../../common/Formatting";
import { KeyValue } from "../../../../common/BaseClasses";

interface IProps {
    managers: KeyValue<string, string>[],
    data: Report1Item[];
    dateFrom: Date;
    dateTo: Date;
}
interface IState {
    splitBy: "month" | "week" | "day" | "year";
    valueType: "bysumm" | "bycount";
}

@observer
export class ByUsersChart extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            splitBy: "month",
            valueType: "bysumm"
        };
    }

    private changePeriod = (value: "month" | "week" | "day" | "year") => {
        this.setState({
            splitBy: value
        });
    }

    private changeType = (value: "bysumm" | "bycount") => {
        this.setState({
            valueType: value
        });
    }
    render() {

        const labels: any[] = [];
        const localize: any = ru.localize;
        switch (this.state.splitBy) {
            case "year":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setFullYear(d.getFullYear() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "yyyy"),
                        label: formatDateToMask(d, "yyyy"),
                    })
                }
                break;
            case "month":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setMonth(d.getMonth() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "MM.yyyy"),
                        label: `${localize.month(d.getMonth(), { width: 'abbreviated' })}, ${d.getFullYear()}`
                    })
                }
                break;
            case "day":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setDate(d.getDate() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "dd.MM.yyyy"),
                        label: `${formatShortDate(d)}, ${localize.day(d.getDay(), { width: 'abbreviated' })}`
                    })
                }
                break;
        }

        const colors = ["#FA8072",
            "#1E90FF",
            "#FF00FF",
            "#00FF7F",
            "#FFD700",
            "#00FFFF",
            "#66CDAA",
            "#0000FF",
            "#FFB6C1",
            "#FFFF00"
        ];


        this.props.data.forEach(item => {
            const year = new Date(item.date).getFullYear();
            const month = new Date(item.date).getMonth();
            // let week = new Date(item.date).;
            const day = new Date(item.date).getDay();
            let key = "";
            let label = "";
            switch (this.state.splitBy) {
                case "year":
                    key = formatDateToMask(item.date, "yyyy");
                    label = `${year}`;
                    break;
                case "month":
                    key = formatDateToMask(item.date, "MM.yyyy");
                    label = `${localize.month(month, { width: 'abbreviated' })}, ${year}`;
                    break;
                case "day":

                    key = formatDateToMask(item.date, "dd.MM.yyyy");
                    label = `${formatShortDate(item.date)}, ${localize.day(day, { width: 'abbreviated' })}`;
                    break;
            }
            const index = labels.findIndex(w => w.key == key);
            if (index > -1)
                item.managers.forEach(man => {
                    labels[index][`manager_${man.managerId}_sum`] = (labels[index][`manager_${man.managerId}_sum`] || 0) + man.sum;
                    labels[index][`manager_${man.managerId}_count`] = (labels[index][`manager_${man.managerId}_count`] || 0) + man.ordersCount;
                });
        });
        
        const data = {
            labels: labels.map(w => w.label),
            datasets: this.props.managers.map((w, index) => {
                return {
                    label: w.Value,
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: colors[index % 10],
                    pointBorderColor: colors[index % 10],
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: labels.map(ww => this.state.valueType == "bysumm" ? formatMoney(ww[`manager_${w.Key}_sum`] || 0) : ww[`manager_${w.Key}_count`] || 0)
                };
            })
        };



        return <Row>
            <Col sm={1}>
                <br />
                <br />
                <ButtonToolbar >
                    <ToggleButtonGroup value={this.state.splitBy}
                        type="radio" name="options" defaultValue={"month"} vertical size="sm"
                        onChange={this.changePeriod} style={{ zIndex: 0 }}>
                        <ToggleButton value={"year"}>Год</ToggleButton>
                        <ToggleButton value={"month"}>Месяц</ToggleButton>
                        <ToggleButton value={"day"}>День</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
                <br />
                <br />
                <ButtonToolbar >
                    <ToggleButtonGroup value={this.state.valueType}
                        type="radio" name="options" defaultValue={"bysumm"} vertical size="sm"
                        onChange={this.changeType} style={{ zIndex: 0 }}>
                        <ToggleButton value={"bysumm"}>Сумма</ToggleButton>
                        <ToggleButton value={"bycount"}>Количество</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
            </Col>
            <Col sm={11}>
                <Line
                    data={data} />
            </Col>
        </Row >
    }
}